import { ChevronLeft, ChevronRight } from 'lucide-react';

const longDay = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  timeZone: 'UTC',
});

const arrow =
  'rounded-pill grid size-11 shrink-0 place-items-center disabled:opacity-40 focus-visible:outline-2 focus-visible:outline-forest';

/**
 * Tagwahl „‹ Montag, 19. Oktober ›“ (Board „Belegung · Ressourcen“) über die Tage des sichtbaren
 * Zeitraums; am Rand ist der Pfeil gesperrt, statt in einen Tag ohne Daten zu springen. Der Tag in
 * der Mitte ist zugleich eine Auswahl: jeder Tag des Zeitraums ist mit einem Griff erreichbar.
 */
export function ResourceDayPicker({
  days,
  value,
  onChange,
}: {
  days: string[];
  value: string;
  onChange: (day: string) => void;
}) {
  const index = days.indexOf(value);
  const step = (delta: number) => {
    const next = days[index + delta];
    if (next) onChange(next);
  };
  return (
    <div className="border-line rounded-pill flex h-11 min-w-0 items-center border">
      <button
        type="button"
        aria-label="Vortag"
        disabled={index <= 0}
        onClick={() => step(-1)}
        className={arrow}
      >
        <ChevronLeft size={16} aria-hidden />
      </button>
      <select
        aria-label="Tag"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-11 min-w-0 cursor-pointer appearance-none truncate bg-transparent px-1.5 text-center text-sm font-bold"
      >
        {days.map((day) => (
          <option key={day} value={day}>
            {longDay.format(new Date(`${day}T00:00:00Z`))}
          </option>
        ))}
      </select>
      <button
        type="button"
        aria-label="Folgetag"
        disabled={index < 0 || index >= days.length - 1}
        onClick={() => step(1)}
        className={arrow}
      >
        <ChevronRight size={16} aria-hidden />
      </button>
    </div>
  );
}
